export default __webpack_public_path__ + "static/media/pscLogo.06092b0e.webp";